import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Tooltip from '@mui/material/Tooltip'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'

import ChipButton from '@/components/ui/buttons/ChipButton'
import DeleteConfirmationDialog from '@/components/ui/dialogs/DeleteConfirmationDialog'

export type DeleteAvailabilityDialogProps = {
  isDeleting?: boolean
  onDelete: () => void
}

export function DeleteAvailabilityDialog(props: DeleteAvailabilityDialogProps) {
  const { isDeleting = false, onDelete } = props
  const { t } = useTranslation()

  const [open, setOpen] = useState<boolean>(false)

  const handleToggleDialog = () => {
    setOpen(!open)
  }

  return (
    <>
      <Tooltip title={t('page.meetingLink.deleteAvailabilityDialog.deleteAvailabilityButton.tooltip')}>
        <ChipButton color="error" onClick={handleToggleDialog}>
          <DeleteRoundedIcon />
        </ChipButton>
      </Tooltip>
      <DeleteConfirmationDialog
        isDeleting={isDeleting}
        maxWidth={800}
        onClose={handleToggleDialog}
        onDelete={onDelete}
        open={open}
        title={t('dialog.deleteConfirmation.availabilities.title')}
        message={t('dialog.deleteConfirmation.availabilities.message')}
      />
    </>
  )
}

export default DeleteAvailabilityDialog
